import { render } from "./Footer.vue?vue&type=template&id=8dcf5492"
const script = {}
script.render = render

export default script